var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCfg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.513 24.179a14.7 14.7 0 0 1-1.39-6.26c0-8.176 6.655-14.805 14.864-14.805 4.57 0 8.66 2.055 11.386 5.289L31 7.044A16.978 16.978 0 0 0 17.987 1C8.605 1 1 8.575 1 17.92c0 2.556.57 4.98 1.588 7.153l1.925-.894zm13.474 3.787C12.417 27.967 7.9 23.469 7.9 17.92c0-5.548 4.517-10.046 10.087-10.046a10.08 10.08 0 0 1 7.726 3.589l1.627-1.36a12.203 12.203 0 0 0-9.353-4.344c-6.743-.001-12.21 5.444-12.21 12.16 0 6.717 5.467 12.162 12.21 12.162v-2.115zm0-5.288c1.47 0 2.783-.662 3.66-1.7l1.486 1.906a7.157 7.157 0 0 1-5.146 2.172c-3.958 0-7.166-3.196-7.166-7.138s3.21-7.138 7.167-7.138c2.204 0 4.175.991 5.49 2.55l-1.83 1.53a4.775 4.775 0 0 0-3.66-1.7c-2.639 0-4.778 2.13-4.778 4.758 0 2.628 2.138 4.76 4.777 4.76z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCfg);
export default __webpack_public_path__ + "static/media/CFG.07400af13d56a740b5d11e24954b6258.svg";
export { ForwardRef as ReactComponent };